var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"login-card"},[_c('h1',[_vm._v("Acceso desde MSP")]),_c('p',{attrs:{"role":"status"}},[_vm._v(_vm._s(_vm.message))]),(_vm.failed)?_c('a',{attrs:{"href":"/msp"}},[_vm._v("Volver al portal MSP")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }